Ext.define('SA.view.DeleteDatasetWindow', {
    alias: 'widget.delete-dataset-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-delete-dataset-window',
    includeHeader: false,

    initComponent() {
        this.callParent();

        this.cancelBtn = this.down('#cancelBtn');
        this.proceedBtn = this.down('#proceedBtn');
    },

    getBodyItems() {
        var datasetName = Ext.htmlEncode(this.datasetName);

        return {
            xtype: 'component',
            cls: 'sa-delete-dataset-window-body-content',

            html: [
                '<svg><use href="#sa-icon-warning"></use></svg>',
                '<div class="sa-delete-dataset-window-message">',
                    `Really delete your <strong>‘${datasetName}’</strong> dataset?`,
                '</div>'
            ]
        };
    },

    getFooterItems() {
        return [
            {
                xtype: 'sa-button',
                handler: () => this.fireEvent('click:delete'),
                itemId: 'proceedBtn',
                text: 'Yes, delete dataset',
                width: 140
            }, {
                xtype: 'sa-button',
                cls: 'sa-delete-dataset-window-no-btn',
                handler: () => this.destroy(),
                itemId: 'cancelBtn',
                text: 'Keep dataset',
                ui: 'primary'
            }
        ];
    },

    setDeleting() {
        this.cancelBtn.setDisabled(true);

        this.proceedBtn.removeCls('sa-button-over');
        this.proceedBtn.setText('Deleting dataset…');
        this.proceedBtn.setDisabled(true);
    }
});